module.exports = __webpack_public_path__ + "static/img/game11.81195bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game11.jpg
// module id = IbD2
// module chunks = 1